export default __webpack_public_path__ + "static/media/jar.8e9ccdc4.png";